for (const uploadButton of document.querySelectorAll('form .direct-upload-button input[type="file"]')) {
    uploadButton.addEventListener('change', function (e) {
        enterSavingState(this);

        // set time and handle form
        const time = new Date().getTime();
        handleForm(e, this, true, () => {
            // exit saving state if 500ms have passed
            const passedTime = new Date().getTime() - time;
            if (passedTime > 750) {
                exitSavingState(this);
                return;
            }
            // else wait until 500ms have passed and then exit saving state
            setTimeout(() => {
                exitSavingState(this);
            }, passedTime - 750 * -1);
        });
    }, false);
}

function enterSavingState(elem) {
    // Set disabled
    elem.disabled = true;
    elem.parentElement.classList.add('disabled');
    // Remove icon
    elem.parentElement.querySelector('i').classList.add('d-none');
    // Prepend spinner
    elem.parentElement.prepend(document.createElement('span'));
    elem.parentElement.querySelector('span').classList.add('spinner-border', 'spinner-border-sm', 'mr-2');
}

function exitSavingState(elem) {
    elem.disabled = false;
    elem.parentElement.classList.remove('disabled');

    // remove bootstrap spinner from button
    elem.parentElement.querySelector('span').remove();
    elem.parentElement.querySelector('i').classList.remove('d-none');
}
